import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popup24 from "@carbon/icons-react/lib/popup/24";
import Close24 from "@carbon/icons-react/lib/close/24";
import CaretDown32 from "@carbon/icons-react/lib/caret--down/32";
import { Icon } from "@prestosports/commons-ui";
import StreamStyles from "../styles/StreamStyles";

const StreamHeader = ({
	handleClose,
	streams,
	handleStreamSelection,
	stream,
	dragRef,
	onOpenPopout,
	popout
}) => {
	const classes = StreamStyles();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
	};

	const handleOptionSelect = (s) => {
		if (s.id) {
			handleStreamSelection(s.id);
		}
		setAnchorEl(null);
	};

	return (
		<Box ref={dragRef} className={classes.streamHeaderPaper}>
			<Box className={classes.streamHeaderTitleBox}>
				<Button
					startIcon={
						<Icon>
							<CaretDown32 />
						</Icon>
					}
					size="small"
					onClick={handleClick}
					color="primary"
				>
					{stream.name}
				</Button>
				<Menu
					style={{ zIndex: Number.MAX_SAFE_INTEGER }}
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleOptionSelect}
				>
					{streams.map((s) => (
						<MenuItem
							disabled={stream.id === s.id}
							onClick={() => handleOptionSelect(s)}
						>
							{s.name}
						</MenuItem>
					))}
				</Menu>
			</Box>
			{!popout && (
				<Box className={classes.paperHeaderButtonGroup}>
					<IconButton
						aria-label="Open stream in new window"
						color="secondary"
						onClick={onOpenPopout}
					>
						<Popup24 />
					</IconButton>
					<IconButton
						aria-label="Close stream"
						color="secondary"
						onClick={handleClose}
					>
						<Close24 />
					</IconButton>
				</Box>
			)}
		</Box>
	);
};

export default StreamHeader;
